import React, { useEffect, useState } from 'react'
import { Input } from 'sutra/components/Input/Input'

import {
  PaneContainer,
  PaneDescription,
  PaneHeading,
} from 'features/charts-v2/components/filter-popover-pane.styles'
import { FilterPopoverPaneFooter } from 'features/charts-v2/components/FilterPopoverPaneFooter/FilterPopoverPaneFooter'

interface FilterPopoverSmartSearchPaneProps {
  // null = not applied, undefined = applied but empty, string = applied with value.
  smartSearchValue: string | null | undefined
  onApply: (value: string) => void
  onClear: () => void
}

// In-popover editor for Smart search. Apply is the only commit point — the
// popover no longer creates an applied-but-empty card just by opening this
// pane.
export const FilterPopoverSmartSearchPane: React.FC<
  FilterPopoverSmartSearchPaneProps
> = ({ smartSearchValue, onApply, onClear }) => {
  const [draft, setDraft] = useState(smartSearchValue ?? '')

  // Re-sync the draft when the committed value changes externally.
  useEffect(() => {
    setDraft(smartSearchValue ?? '')
  }, [smartSearchValue])

  const trimmed = draft.trim()
  const applyDisabled = trimmed.length === 0

  const handleApply = (): void => {
    if (applyDisabled) return
    onApply(trimmed)
  }

  return (
    <PaneContainer>
      <PaneHeading>Smart search</PaneHeading>
      <PaneDescription>
        Searches by meaning — surfaces posts about a concept even when they
        don&apos;t contain the exact words.
      </PaneDescription>
      <Input
        placeholder="Type a phrase to search..."
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleApply()
        }}
      />
      <FilterPopoverPaneFooter
        applyDisabled={applyDisabled}
        clearDisabled={smartSearchValue === null}
        onApply={handleApply}
        onClear={onClear}
      />
    </PaneContainer>
  )
}
